export const locale = {
    lang: 'es',
    data: {
      'WIZARD': {
        'TITLEOBLI':'Obligaciones del patrón',
        'TESTTITULO': 'TITULO DEL WIZARD.',
        'CARGANDO': 'Cargando productos adquiridos.',
        'SINPRODS': 'No ha adquirido este producto.',
        'LANDING': {
          'PRODUCTO': {

            'DOCUMENTADOR_TITLE':{
              'TITLE1':'Política de prevención de riesgos psicosociales',
              'TITLE2':'Identificación y análisis de factores de riesgo psicosocial',
              'TITLE3':'Identificación y análisis de factores de riesgo psicosocial, y evaluación del entorno organizacional',
              'TITLE4':'Medidas de prevención y acciones de control de los factores de riesgo psicosocial, de violencia laboral y promoción del entorno organizacional favorable',
              'TITLE5':'Acciones y programas para la prevención de los factores de riesgo psicosocial, promoción del entorno organizacional favorable, y prevención de la violencia laboral',
              'TITLE6':'Programa de intervención con evaluaciones específicas y medidas de control',
              'TITLE7':'Identificación de los trabajadores que fueron sujetos a acontecimientos traumáticos severos y canalización para su atención',
              'TITLE8':'Exámenes médicos y evaluaciones psicológicas a los trabajadores expuestos a violencia laboral y/o factores de riesgo psicosocial',
              'TITLE9':'Difusión y promoción de información a los trabajadores',
              'TITLE10':'Llevar registros'
            },
            'GUIA':{
              'TITULO': 'BIENVENIDO A LA GUÍA DE NOM-035-STPS-2018',
              'CHAN_INF':'Cargando productos',
              'NOM35':{
              'TITULO_LANFIG': 'BIENVENIDO A NORMA-035',
              'TITULO_PRODUCT2':'Norma-035',
              'ENTRAR':'Iniciar',
              'DONE':'Fecha aplicación',
              },
              'NOM35PLA':{
              'TITULO_LANFIG': 'BIENVENIDO A NORMA-035 PLATA',
              'TITULO_PRODUCT2':'Norma-035 plata',
              'ENTRAR':'Iniciar',
              'DONE':'Fecha aplicación',
              },
              'NOM35BETHE':{
              'TITULO_LANFIG': 'BIENVENIDO A NORMA-035 BETTER',
              'TITULO_PRODUCT2':'Norma-035 better',
              'ENTRAR':'Iniciar',
              'DONE':'Fecha aplicación',
              },
              'CURRENT': 'Guía de implementación',
              'DESCRIPTION': 'Consulte la información general de la norma y responda la información que se solicita de su centro de trabajo y las tareas de cada obligación del patrón.',
              'BUTTON': 'INICIO',
              'FINISHED': '',
              'CT_NAME':'Centro de trabajo: ',
            },
            'ENCUESTADOR':{
              'TITULO': 'BIENVENIDA AL ENCUESTADOR DE NOM-035-STPS-2018.',
              'CURRENT': 'Encuestador',
              'DESCRIPTION' : 'Prepare la información requerida de los colaboradores que participarán en la encuesta y programe su lanzamiento y plan de comunicación.',
              'BUTTON': 'INICIO',
              'FINISHED': ''
            },
            'EXPEDIENTE':{
              'TITULO': 'BIENVENIDA AL EXPEDIENTE DE NOM-035-STPS-2018',
              'CURRENT': 'Expedientes',
              'DESCRIPTION' : 'Agregue evidencias de la atención clínica que recibieron los colaboradores que sufrieron acontecimientos traumáticos severos.',
              'BUTTON': 'INICIO',
              'FINISHED': ''
            },
            'CENTROS':{
              'TITULO': 'BIENVENIDA AL EXPEDIENTE DE NOM-035-STPS-2018',
              'CURRENT': 'Centros de trabajo',
              'DESCRIPTION' : 'Consulte la información de cada centro de trabajo y el progreso de respuesta de la guía de implementación, entre otras cosas.',
              'BUTTON': 'INICIO',
              'FINISHED': ''
            },
            'RESULTADOS':{
              'TITULO': 'Resultados de NOM-035',
              'CURRENT': 'Resultados',
              'DESCRIPTION' : 'Explore y analice los resultados de la encuesta y la calificación final del centro de trabajo de acuerdo a lo establecido por la NOM-035-STPS-2018.',
              'BUTTON': 'START',
              'FINISHED': '',
              'STEPS':{
                '1': 'Inicio',
                '2': 'Información general',
                '3': 'Respuestas',
                '4': 'Tablero',
                '5': 'Por categoria',
                '6': 'Por dominio',
                '7': 'Calificacion final',
                '8': 'Respuestas',
                '9': 'Respuestas-2',
                '10': 'Respuestas-3',
                '11': 'Información general'
              }
            }
          },

        },

        'MODAL':{
          'LABEL01':'Cargando...'
        },

        'CT_INFORMACION':{
          'Label01':'Favor de llenar la siguiente información de su centro de trabajo:',
          'Label02':'',
          'TABLE':{
            'LabelTable01':'Objetivo',
            'LabelTable02':'Principales actividades realizadas'
          },
          'LISTA':{
            'TITULO': 'Centros de trabajo de la empresa',
            'SUBTI': 'Consulte la información de sus centros de trabajo',
            'CARGANDO': 'Cargando centros de trabajo almacenados',
            'NOCENTROS': 'Aún no ha cargado ningún centro de trabajo',
            'NODATA': 'Aún no ha cargado ningúna base de datos',
            'CENTRO': {
              'MOREINFO': 'Haga clic aquí para ver más detalles',
              'TITULO': 'Información del centro de trabajo',
              'NOMBRE': 'Nombre',
              'ACTIVIDAD': 'Actividad principal',
              'RESPO': 'Nombre del responsable',
              'EMAIL': 'Correo electrónico',
              'EMAILRS': 'Correo electrónico del responsable de la razón social',
              'DOMI': 'Domicilio',
              'ACCIONES': 'Acciones',
              'AUTOLOGIN': 'Consultar progreso de la guía de implementación',
              'CTADV': 'Avance de la Guía de Implementación por centro de trabajo',
              'PDF':'Generar PDF de evidencias'
            }
          }

        },
        'PDF':{
          'BTN':'Generar PDF de evidencias '
        },
        'TIMELINE':{
          'TIMELINE':'Cronograma de implemetanción',
          'LABEL01':'Avance guía de implementación',
          'STEPS':{
            'STEP01': 'Etapa 1:' ,
            'STEP02': 'Del 23/10/2019 al 23/10/2020' ,
            'STEP03': 'Etapa 2:' ,
            'STEP04': 'a partir del 23/10/2020 ' ,
          },
          'TABLE':{
            'LABEL01':'Requisito',
            'LABEL02':'Actividad ',
            'LABEL03':'Entregable'

          }

        },
        'STEPSTAT': {
          'LOCK': 'Paso bloqueado',
          'PEND': 'Paso abierto',
          'COMP': 'Paso completado'
        },
        'NOPRODUCTS': {
          'TITULO': 'Su empresa no cuenta con productos adquiridos.',
          'SUBTI': 'Información sobre la oferta.'
        },
        'MENU_GUIA': {
          'TITULO': 'CGO NOM-035-STPS-2018.',
          'MENU': {
            'MN1': {
              'TITULO': 'Vista general ',
            },
            'MN2': {
              'TITULO': 'Aspectos generales',
            },
            'MN3': {
              'TITULO': 'Objetivo ',
            },
            'MN4': {
              'TITULO': 'Campo de aplicación',
            },
            'MN5': {
              'TITULO': 'Referencias ',
            },
            'MN6': {
              'TITULO': 'Definiciones de la norma',
            },
            'MN7': {
              'TITULO': 'Definiciones de la plataforma ',
            },
            'MN8': {
              'TITULO': 'Obligaciones del patrón ',
            },
            'MN9': {
              'TITULO': 'Política de prevención de riesgos psicosociales ',
            },
            'MN10': {
              'TITULO': 'Encuesta de 16-50 colaboradores ',
            },
            'MN11': {
              'TITULO': 'Encuesta más de 50 colaboradores ',
            },
            'MN12': {
              'TITULO': 'Medidas de prevención y control ',
            },
            'MN13': {
              'TITULO': 'Canal de quejas y denuncias ',
            },
            'MN14': {
              'TITULO': 'Acciones y programas preventivos ',
            },
            'MN15': {
              'TITULO': 'Programa de intervención con evaluaciones y medidas de control ',
            },
            'MN16': {
              'TITULO': 'Encuesta de acontecimientos traumáticos severos',
            },
            'MN17': {
              'TITULO': 'Exámenes médicos y evaluaciones psicológicas ',
            },
            'MN18': {
              'TITULO': 'Difusión y promoción de información ',
            },
            'MN19': {
              'TITULO': 'Registros',
            },
            'MN20': {
              'TITULO': 'Documentos de soporte',
            },
            'MN21': {
              'TITULO': 'Guía de referencia I',
            },
            'MN22': {
              'TITULO': 'Guía de referencia II',
            },
            'MN23': {
              'TITULO': 'Guía de referencia III',
            },
            'MN24': {
              'TITULO': 'Guía de referencia IV',
            },
            'MN25': {
              'TITULO': 'Guía de referencia V',
            },
            'MN26': {
              'TITULO': 'Tareas pendientes',
            },'MN27': {
              'TITULO': 'Obligaciones de los colaboradores',
            },
            'MN28': {
              'TITULO': 'Información del centro de trabajo',
            },
            'MN29': {
              'TITULO': 'Cronograma',
            },

          }
        },
        'PATRON': {
          '0':{
            'SECCION':'Política de prevención de riesgos psicosociales'
          },
          '1':{
            'SECCION':'Encuesta de 16-50 colaboradores'
          },
          '2':{
            'SECCION':'Encuesta más de 50 colaboradores'
          },
          '3':{
            'SECCION':'Canal de quejas y denuncias'
          },
          '4':{
            'SECCION':'Acciones y programas preventivos'
          },
          '5':{
            'SECCION':'Programa de intervención con evaluaciones y medidas de control'
          },
          '6':{
            'SECCION':'Encuesta de acontecimientos traumáticos severos'
          },
          '7':{
            'SECCION':'Exámenes médicos y evaluaciones psicológicas'
          },
          '8':{
            'SECCION':'Difusión y promoción de información'
          },
          '9':{
            'SECCION':'Registros'
          },
        },
        'DEFINICIONES_NORMA':{
          'SPAN01':'Para efectos de la NOM-035-STPS-2018 se consideran las siguientes definiciones:',
          'SPAN02':'Para efectos de la plataforma se consideran las siguientes definiciones:',
          'DEF1':{
            'TITLE_DEF': "1.- Acontecimiento traumático severo",
            'DEF': 'Aquel experimentado durante o con motivo del trabajo que se caracteriza por la ocurrencia de la muerte o que representa un peligro real para la integridad física de una o varias personas y que puede generar trastorno de estrés postraumático para quien lo sufre o lo presencia. Algunos ejemplos son: explosiones, derrumbes, incendios de gran magnitud; accidentes graves o mortales, asaltos con violencia, secuestros y homicidios, entre otros.',
          },
          'DEF2':{
            'TITLE_DEF': "2.- Apoyo social ",
            'DEF': "Las acciones para mejorar las relaciones sociales en el trabajo en las que se promueve el apoyo mutuo en la solución de problemas de trabajo entre trabajadores, superiores y/o subordinados. Algunos ejemplos de medidas para constituir un apoyo social práctico y oportuno en el lugar de trabajo son: afianzar la relación supervisores-trabajadores; propiciar la ayuda mutua entre los trabajadores; fomentar las actividades culturales y del deporte, y proporcionar ayuda directa cuando sea necesario, entre otros.",
          },
          'DEF3':{
            'TITLE_DEF': "3.- Autoridad laboral",
            'DEF': "Las unidades administrativas competentes de la Secretaría que realizan funciones de inspección y vigilancia en materia de seguridad y salud en el trabajo, y las correspondientes de las entidades federativas, que actúen en auxilio de aquellas."
          },
          'DEF4':{
            'TITLE_DEF': "4.- Centro de trabajo ",
            'DEF': "El lugar o lugares, tales como edificios, locales, instalaciones y áreas, donde se realicen actividades de explotación, aprovechamiento, producción, comercialización, transporte y almacenamiento o prestación de servicios, en los que laboren personas que estén sujetas a una relación de trabajo."

          },
          'DEF5':{
            'TITLE_DEF': "5.- Diagnóstico de seguridad y salud en el trabajo",
            'DEF': "La identificación de las condiciones inseguras o peligrosas; de los agentes físicos, químicos o biológicos o de los factores de riesgo ergonómico o psicosocial capaces de modificar las condiciones del ambiente laboral; de los peligros circundantes al centro de trabajo, así como de los requerimientos normativos en materia de seguridad y salud en el trabajo que resulten aplicables."
          },
          'DEF6':{
            'TITLE_DEF': "6.- Entorno organizacional favorable",
            'DEF': "Aquel en el que se promueve el sentido de pertenencia de los trabajadores a la organización; la formación para la adecuada realización de las tareas encomendadas; la definición precisa de responsabilidades para los trabajadores del centro de trabajo; la participación proactiva y comunicación entre trabajadores; la distribución adecuada de cargas de trabajo, con jornadas de trabajo regulares conforme a la Ley Federal del Trabajo, y la evaluación y el reconocimiento del desempeño."
          },
          'DEF7':{
            'TITLE_DEF': "7.- Factores de riesgo psicosocial",
            'DEF': "Aquellos que pueden provocar trastornos de ansiedad, no orgánicos del ciclo sueño-vigilia y de estrés grave y de adaptación, derivado de la naturaleza de las funciones del puesto de trabajo, el tipo de jornada de trabajo y la exposición a acontecimientos traumáticos severos o a actos de violencia laboral al trabajador, por el trabajo desarrollado. Comprenden las condiciones peligrosas e inseguras en el ambiente de trabajo; las cargas de trabajo cuando exceden la capacidad del trabajador; la falta de control sobre el trabajo (posibilidad de influir en la organización y desarrollo del trabajo cuando el proceso lo permite); las jornadas de trabajo superiores a las previstas en la Ley Federal del Trabajo, rotación de turnos que incluyan turno nocturno y turno nocturno sin períodos de recuperación y descanso; interferencia en la relación trabajo-familia, y el liderazgo negativo y las relaciones negativas en el trabajo."
          },'DEF8':{
            'TITLE_DEF': "8.- Medidas de prevención y acciones de control ",
            'DEF': "Aquellas acciones que se adoptan para prevenir y/o mitigar los factores de riesgo psicosocial y, en su caso, para eliminar las prácticas opuestas al entorno organizacional favorable y los actos de violencia laboral, así como las acciones implementadas para darles seguimiento."
          },'DEF9':{
            'TITLE_DEF': "9.- Política de prevención de riesgos psicosociales ",
            'DEF': "La declaración de principios y compromisos que establece el patrón para prevenir los factores de riesgo psicosocial y la violencia laboral, y para la promoción de un entorno organizacional favorable, con el objeto de desarrollar una cultura en la que se procure el trabajo digno o decente, y la mejora continua de las condiciones de trabajo."
          },
          'DEF10':{
            'TITLE_DEF': "10.- Trabajador",
            'DEF': "La persona física que presta a otra, física o moral, un trabajo personal subordinado."
          },'DEF11':{
            'TITLE_DEF': "11.- Trabajo ",
            'DEF': "Toda actividad humana, intelectual o material, independientemente del grado de preparación técnica requerido por cada profesión u oficio."
          },'DEF12':{
            'TITLE_DEF': "12.- Violencia laboral ",
            'DEF': "Aquellos actos de hostigamiento, acoso o malos tratos en contra del trabajador, que pueden dañar su integridad o salud."
          }
        },
        'DEFINICIONES_TABLA':{
          'SPAN01':'Para efectos de la NOM-035-STPS-2018, se consideran las siguientes definiciones:',
          'SPAN02':'Para efectos de la plataforma, se consideran las siguientes definiciones:',

          'DEF1':{
          'TITLE_DEF':'1.- Disposición ',
          'DEF':'Es una prescripción adoptada por STPS para establecer un tipo de norma con carácter reglamentario para ser cumplida por parte del patrón.'
          },
          'DEF2':{
            'TITLE_DEF':'2.- Definición GPTW ',
            'DEF':'Explicación por parte de GPTW para resumir lo que se puede hacer para cumplir con la disposición.'
          },
          'DEF3':{
            'TITLE_DEF':'3.- Apoyo ',
            'DEF':'Ejemplo de documentos que se pueden consultar en la plataforma y videos con ideas de lo que se puede mostrar como evidencia para el cumplimiento de la disposición.'
          },
          'DEF4':{
            'TITLE_DEF':'4.- Criterios de aceptación ',
            'DEF':'Conjunto de directrices que establece las características de cumplimiento de una disposición y que son evaluadas por un representante de una unidad de verificación acreditada y aprobada para verificar el grado de cumplimiento de la NOM-035-STPS-2018.'
          },
          'DEF5':{
            'TITLE_DEF':'5.- Tareas ',
            'DEF':'Actividades que debe realizar el representante del centro de trabajo en cumplimiento a la disposición y que incluye un tipo de comprobación (evidencia) documental o entrevista según aplique.  Cada tarea es evaluada por un representante de un centro de trabajo que indica si cumple, no cumple o no aplica.'
          },

        },
        'ASPECTOS_GENERALES':{
          'TITLE':'Aspectos generales',
          'ASP1':{
            'TITLE':'Objetivo'
          },
          'ASP2':{
            'TITLE':'Campo de aplicación'
          },
          'ASP3':{
            'TITLE':'Referencias'
          },
          'ASP4':{
            'TITLE':'Definiciones de la norma'
          },
          'ASP5':{
            'TITLE':'Definiciones de la plataforma '
          },

        },
        'OBJETIVO':{
          'TITLE':'Manual NOM-035-STPS-2018.',
          'SUBTITLE':'Por Great Place to Work',
          'DESCRIPTION':'La NOM-035-STPS-2018 es un instrumento que permite identificar y analizar de forma general los factores de riesgo psicosocial en los centros de trabajo; así como evaluar el entorno organizacional en el que los trabajadores desarrollan sus actividades.',
          'MENU':{
            'MAINTITLE':'Particulares',
            'TITLE1':'Promoción de un entorno organizacional favorable.',
            'TITLE2':'Prevención de factores de riesgo psicosocial.',
            'TITLE3':'Prevención de violencia laboral.',
            'TITLE4':'Difundir en el centro de trabajo la política de prevención de riesgos psicosociales.',
          }
        },
        'CAMPO_APLICACION':{
          'TITLE':'La presente Norma Oficial Mexicana rige en todo el territorio nacional y aplica en todos los centros de trabajo, de acuerdo con lo siguiente:',
           'MENU':{
             'SUB1':'a) Para centros de trabajo en los que laboren hasta quince trabajadores deberán cumplir con lo dispuesto por los numerales 5.1, 5.4, 5.5, 5.7, 8.1 y 8.2 de la presente norma',
             'SUB2':'b) Para centros de trabajo en los que laboren entre dieciséis y cincuenta trabajadores deberán cumplir con los numerales 5.1, 5.2, del 5.4 al 5.8, 7.1, inciso a), 7.2, del 7.4 al 7.9, y el capítulo 8 de esta norma',
             'SUB3':'c) Para centros de trabajo en los que laboren más de 50 trabajadores deberán cumplir con los numerales 5.1, del 5.3 al 5.8, 7.1, inciso b), del 7.2 al 7.9 y el capítulo 8 de la presente norma',
           },
           'SUBTITLE':'Aquellos centros de trabajo que cuenten con certificado de cumplimiento con la norma mexicana NMX-R-025-SCFI-2015 vigente, darán por esa condición cumplimiento con las obligaciones y numerales siguientes:',
           'MENUSUB':{
             'SUB1':'5.1 inciso b), 8.1, inciso b), 8.2 incisos a), subinciso 2), e) y g); 5.7 inciso d)',
           }
        },
        'REFERENCIAS':{
          'TITLE':'Para la correcta interpretación y aplicación de la presente norma se deberán consultar las siguientes normas oficiales mexicanas y la norma mexicana, vigentes, o las que las sustituyan:',
          'CONTENT':{
            'CONTENT1':'3.1 NOM-019-STPS-2011, constitución, integración, organización y funcionamiento de las comisiones de seguridad e higiene',
            'CONTENT2':'3.2 NOM-030-STPS-2009, servicios preventivos de seguridad y salud en el trabajo-funciones y actividades',
            'CONTENT3':'3.3 NMX-R-025-SCFI-2015, en igualdad laboral y no discriminación'
          }
        },
        'OBLIGACIONES':{
          'TITLE':'Obligaciones del patrón',
          'CONTENT':{
            'CONTENT1':'Política de prevención de riesgos psicosociales',
            'CONTENT2':'Encuesta de 16-50 colaboradores',
            'CONTENT3':'Encuesta más de 50 colaboradores',
            'CONTENT4':'Medidas de prevención y control',
            'CONTENT5':'Canal de quejas y denuncias',
            'CONTENT6':'Acciones y programas preventivos',
            'CONTENT7':'Programa de intervención con evaluaciones y medidas de control',
            'CONTENT8':'Encuesta de acontecimientos traumáticos severos',
            'CONTENT9':'Exámenes médicos y evaluaciones psicológicas',
            'CONTENT10':'Difusión y promoción de información',
            'CONTENT11':'Registros'
          }

        },
        'COLABORADORES':{
          'TITLE':'Obligaciones de los colaboradores.',
          'SUBTITLE':'Detalle de control',
          'TABLE_LABEL01':'Disposición'
        },
        'DOCUMENTO_SOPORTE':{
          'TITLE':'Documentos de soporte',
          'CONTENT1':{
            'DOC1':'Guía de referencia I',
            'DOC2':'Guía de referencia II',
            'DOC3':'Guía de referencia III',
            'DOC4':'Guía de referencia IV',
            'DOC5':'Guía de referencia V',
          }
        },
        'DOCUMENTADOR':{
          'LABEL01':'Reproducir video',
          'LABEL02':'Clic ',
          'LABEL03':' para consultar la NOM-035-STPS-2018 del sitio oficial',
          'LABEL04':'aquí',
          'LABEL05':'Disposición 6.1 - 6.7'
        },
        'TABLE_STEP':{
          'TITLE':'Detalle control',
          'LINK':'De clic para más información',
          'TABLE1':{
            'TITLE':'Detalle de Control',
            'DIS':'Disposición',
            'DEF':'Definición GPTW',
            'APOYO': 'Apoyo',
            'CT_ACEPT':'Criterios de aceptación'
          },
          'TABLE2':{
            'EST':'Estatus',
            'DATE':'Fecha',
            'NUM': 'Numeral',
            'DES':'Descripción tarea',
            'EVD':'Evidencia',
            'OBS':'Observaciones',
            'DOC':'Apoyo',
            'FILE': 'Carga de archivos',
            'TASK': 'Agregar tarea',
            'ACT': 'Actividad',
            'CHECK': 'Verificado',

          },
          'SPAN01':'Agregar más tareas'
        },
        'LISTATAREAS':{
          'LABEL01':'Descripción',
          'LABEL02':'Estatus',
          'LABEL03':'Observaciones',
          'LABEL04':'Ver'

        },
        'MENSAJES':{
          'ADVICE1':'La evidencia no puede quedar vacía',
          'ADVICE2':'El archivo se subió correctamente',
          'ADVICE3':'Ocurrió un error',
          'ADVICE4':'¿Seguro que desea crear una nueva tarea?',
          'ADVICE5':'El campo de observaciones no puede estar vacío',
          'ADVICE6':'Actualizando',
          'ADVICE7':'El archivo se subió correctamente',
          'ADVICE8':'No se pueden eliminar todos los archivos si el estatus de la tarea es "Cumple". Cambie el estatus para eliminar este archivo.',
          'ADVICE9':'El archivo se eliminó correctamente',
          'ADVICE10':'Campos evidencias y archivos vacíos', // No se ocupa
          'ADVICE11':'El campo de observaciones no puede estar vacío',
          'ADVICE12':'Cancelar',
          'ADVICE13':'Sí',
          'ADVICE14':'¿Seguro que desea crear una nueva actividad?',
        },
        'GUIA1':{
          'title': 'Guía de referencia I',
          'subtitle': 'EJEMPLO DE CUESTIONARIO PARA IDENTIFICAR A LOS TRABAJADORES QUE FUERON SUJETOS A ACONTECIMIENTOS TRAUMÁTICOS SEVEROS',
          'content': 'El contenido de esta guía es un complemento para la mejor comprensión de la presente norma y no es de cumplimiento obligatorio.',
          'content2': 'En esta guía, se presenta un ejemplo de cuestionario que permite identificar a los trabajadores que han sido sujetos a acontecimientos traumáticos severos y que requieren valoración clínica.',
          'def':'CUESTIONARIO PARA IDENTIFICAR A LOS TRABAJADORES QUE FUERON SUJETOS A ACONTECIMIENTOS TRAUMÁTICOS SEVEROS. Marque una "X" a la respuesta que se le indica.',
          'SEC':'Sección pregunta: ',
          'RES':'Respuesta SI/NO.',
          'SURVEY':{
            'QUES1':'I.- Acontecimiento traumático severo.',
            'QUESTIONS1':{
                'ques1': '¿Ha presenciado o sufrido alguna vez, durante o con motivo del trabajo un acontecimiento como los siguientes:',
                'ques2': 'accidente que tenga como consecuencia la muerte, la pérdida de un miembro o una lesión grave?',
                'ques3': 'asaltos?',
                'ques4': 'actos violentos que derivaron en lesiones graves?',
                'ques5' : 'secuestros?',
                'ques6': 'amenazas?',
                'ques7': 'cualquier otro que ponga en riesgo su vida o salud, y/o la de otras personas?'
            },
            'QUES2':'II.- Recuerdos persistentes sobre el acontecimiento (durante el último mes):',
            'QUESTIONS2':{
                'ques1': '¿Ha tenido recuerdos recurrentes sobre el acontecimiento que le provocan malestares?',
                'ques2': '¿Ha tenido sueños de carácter recurrente sobre el acontecimiento, que le producen malestar?',
            },
            'QUES3':'III.- Esfuerzo por evitar circunstancias parecidas o asociadas al acontecimiento (durante el último mes):',
            'QUESTIONS3':{
                'ques1': '¿Se ha esforzado por evitar todo tipo de sentimientos, conversaciones o situaciones que le puedan recordar el acontecimiento?',
                'ques2': '¿Se ha esforzado por evitar todo tipo de actividades, lugares o personas que motivan recuerdos del acontecimiento?',
                'ques3': '¿Ha tenido dificultad para recordar alguna parte importante del evento?',
                'ques4': '¿Ha disminuido su interés en sus actividades cotidianas?',
                'ques5': '¿Se ha sentido usted alejado o distante de los demás?',
                'ques6': '¿Ha notado que tiene dificultad para expresar sus sentimientos?',
                'ques7': '¿Ha tenido la impresión de que su vida se va a acortar, que va a morir antes que otras personas o que tiene un futuro limitado?',
            },
            'QUES4':'IV.- Afectación (durante el último mes):',
            'QUESTIONS4':{

                'ques1': '¿Ha tenido usted dificultades para dormir?',
                'ques2': '¿Ha estado particularmente irritable o le han dado arranques de coraje?',
                'ques3': '¿Ha tenido dificultad para concentrarse?',
                'ques4': '¿Ha estado nervioso o constantemente en alerta?',
                'ques5': '¿Se ha sobresaltado fácilmente por cualquier cosa?',
            }


          }
        },
        'Guia2':{
          'title': 'Guía de referencia II',
          'subtitle': 'IDENTIFICACIÓN Y ANÁLISIS DE LOS FACTORES DE RIESGO PSICOSOCIAL',
          'content': 'El contenido de esta guía es un complemento para la mejor comprensión de la presente Norma, y no es de cumplimiento obligatorio, puede ser utilizada por aquellos centros de trabajo que tengan hasta 50 trabajadores. La identificación y análisis de los factores de riesgo psicosocial a que se refiere el numeral 8.1, inciso a), de la presente Norma, se podrá realizar aplicando el cuestionario siguiente.',
          'content2': 'CUESTIONARIO PARA IDENTIFICAR LOS FACTORES DE RIESGO PSICOSOCIAL EN LOS CENTROS DE TRABAJO',
          'indica1': 'Para responder las preguntas siguientes considere las condiciones de su centro de trabajo, así como la cantidad y ritmo de trabajo.',
          //indicacion despues de la pregunta 09//
          'indica2': 'Las preguntas siguientes están relacionadas con las actividades que realiza en su trabajo y las responsabilidades que tiene.',
          //indicacion despues de la pregunta 13 //
          'indica3': 'Las preguntas siguientes están relacionadas con el tiempo destinado a su trabajo y sus responsabilidades familiares.',
          //indicacion despues de la pregunta 17 //
          'indica4': 'Las preguntas siguientes están relacionadas con las decisiones que puede tomar en su trabajo',
          //indicacion despues de la pregunta 22 //
          'indica5': 'Las preguntas siguientes están relacionadas con la capacitación e información que recibe sobre su trabajo.',
          //indicacion despues de la pregunta 27 //
          'indica6': 'Las preguntas siguientes se refieren a las relaciones con sus compañeros de trabajo y su jefe.',
          //indicacion despues de la pregunta 40 //
          'indica7': 'Las preguntas siguientes están relacionadas con la atención a clientes y usuarios.',
          //indicacion despues de la pregunta SI/NO //
          'indica8': 'Si su respuesta fue "SÍ", responda las preguntas siguientes. Si su respuesta fue "NO" pase a las preguntas de la sección siguiente.',
          //indicacion despues de la pregunta SI/NO II//
          'indica9': 'Si su respuesta fue "SÍ", responda las preguntas siguientes. Si su respuesta fue "NO", ha concluido el cuestionario.',
          //indicacion despues de la pregunta SI/NO II//
          'indica10': 'Las siguientes preguntas están relacionadas con las actitudes de los trabajadores que supervisa.',
          'labelp':'Soy jefe de otros trabajadores:.',
          'tablas':{//inicio tabla1
              'opc':{
                'opc1': 'Siempre',
                'opc2': 'Casi siempre',
                'opc3': 'Alguna veces',
                'opc4': 'Casi nunca',
                'opc5': 'Nunca',
                    },
               'preguntas':{
                 //tabla1
                    'pre1': 'Mi trabajo me exige hacer mucho esfuerzo físico',
                    'pre2': 'Me preocupa sufrir un accidente en mi trabajo',
                    'pre3': 'Considero que las actividades que realizo son peligrosas',
                    'pre4': 'Por la cantidad de trabajo que tengo debo quedarme tiempo adicional a mi turno',
                    'pre5': 'Por la cantidad de trabajo que tengo debo trabajar sin parar',
                    'pre6': 'Considero que es necesario mantener un ritmo de trabajo acelerado',
                    'pre7': 'Mi trabajo exige que esté muy concentrado',
                    'pre8': 'Mi trabajo requiere que memorice mucha información',
                    'pre9': 'Mi trabajo exige que atienda varios asuntos al mismo tiempo',
                    //tabla 2
                    'pre10': 'En mi trabajo soy responsable de cosas de mucho valor',
                    'pre11': 'Respondo ante mi jefe por los resultados de toda mi área de trabajo',
                    'pre12': 'En mi trabajo me dan órdenes contradictorias',
                    'pre13': 'Considero que en mi trabajo me piden hacer cosas innecesarias',
                    //tabla 3
                    'pre14': 'Trabajo horas extras más de tres veces a la semana',
                    'pre15': 'Mi trabajo me exige laborar en días de descanso, festivos o fines de semana',
                    'pre16': 'Considero que el tiempo en el trabajo es mucho y perjudica mis actividades familiares o personales',
                    'pre17': 'Pienso en las actividades familiares o personales cuando estoy en mi trabajo',
                    //tabla 4
                    'pre18': 'Mi trabajo permite que desarrolle nuevas habilidades',
                    'pre19': 'En mi trabajo puedo aspirar a un mejor puesto',
                    'pre20': 'Durante mi jornada de trabajo puedo tomar pausas cuando las necesito',
                    'pre21': 'Puedo decidir la velocidad a la que realizo mis actividades en mi trabajo',
                    'pre22': '	Puedo cambiar el orden de las actividades que realizo en mi trabajo',
                    //tabla5
                    'pre23': 'Me informan con claridad cuáles son mis funciones',
                    'pre24': 'Me explican claramente los resultados que debo obtener en mi trabajo',
                    'pre25': 'Me informan con quién puedo resolver problemas o asuntos de trabajo',
                    'pre26': 'Me permiten asistir a capacitaciones relacionadas con mi trabajo',
                    'pre27': 'Recibo capacitación útil para hacer mi trabajo',
                    //tabla6
                    'pre28': 'Mi jefe tiene en cuenta mis puntos de vista y opiniones',
                    'pre29': 'Mi jefe ayuda a solucionar los problemas que se presentan en el trabajo',
                    'pre30': 'Puedo confiar en mis compañeros de trabajo',
                    'pre31': 'Cuando tenemos que realizar trabajo de equipo los compañeros colaboran',
                    'pre32': 'Mis compañeros de trabajo me ayudan cuando tengo dificultades',
                    'pre33': 'En mi trabajo puedo expresarme libremente sin interrupciones',
                    'pre34': 'Recibo críticas constantes a mi persona y/o trabajo',
                    'pre35': 'Recibo burlas, calumnias, difamaciones, humillaciones o ridiculizaciones',
                    'pre36': 'Se ignora mi presencia o se me excluye de las reuniones de trabajo y en la toma de decisiones',
                    'pre37': 'Se manipulan las situaciones de trabajo para hacerme parecer un mal trabajador',
                    'pre38': 'Se ignoran mis éxitos laborales y se atribuyen a otros trabajadores',
                    'pre39': 'Me bloquean o impiden las oportunidades que tengo para obtener ascenso o mejora en mi trabajo',
                    'pre40': 'He presenciado actos de violencia en mi centro de trabajo',
                    //pregunta SI/ NO 40
                    'preg':{
                        'pre': 'En mi trabajo debo brindar servicio a clientes o usuarios:',
                        'opc1': 'SÍ',
                        'opc2': 'NO',
                            },
                    //Tabla 7
                    'pre41': 'Atiendo clientes o usuarios muy enojados',
                    'pre42': 'Mi trabajo me exige atender personas muy necesitadas de ayuda o enfermas',
                    'pre43': 'Para hacer mi trabajo debo demostrar sentimientos distintos a los míos',
                    //pregunta SI/ NO 43
                    'preg2':{
                        'pre':  'Soy jefe de otros trabajadores:',
                        'opc1': 'SÍ',
                        'opc2': 'NO',
                            },
                    //Tabla 8
                    'pre44': 'Comunican tarde los asuntos de trabajo',
                    'pre45': 'Dificultan el logro de los resultados del trabajo',
                    'pre46': 'Ignoran las sugerencias para mejorar su trabajo',
                    } // Fin preguntas
                  }//fin tabla

        },
        'Guia3':{
          'title': 'Guía de Referencia III',
          'subtitle': 'IDENTIFICACIÓN Y ANÁLISIS DE LOS FACTORES DE RIESGO PSICOSOCIAL Y EVALUACIÓN DEL ENTORNO ORGANIZACIONAL EN LOS CENTROS DE TRABAJOL',
          'content': 'El contenido de esta guía es un complemento para la mejor comprensión de la presente Norma, y no es de cumplimiento obligatorio, puede ser utilizada por aquellos centros de trabajo que cuenten con más de 50 trabajadores.La identificación y análisis de los factores de riesgo psicosocial y la evaluación del entorno organizacional a que se refiere el numeral 8.1, inciso b) de la presente Norma, se podrá realizar aplicando el cuestionario siguiente',
          'content2': 'CUESTIONARIO PARA IDENTIFICAR LOS FACTORES DE RIESGO PSICOSOCIAL Y EVALUAR EL ENTORNO ORGANIZACIONAL EN LOS CENTROS DE TRABAJO',
          'TABLES':{
            'LABEL01':'Nunca',
            'LABEL02':'Casi nunca',
            'LABEL03':'Algunas veces',
            'LABEL04':'Casi siempre',
            'LABEL05':'Siempre',
            'LABEL06':'SI',
            'LABEL07':'NO',
          },
          'PREGUNTAS':{
            'SECCION1_LABEL01':'En mi trabajo debo brindar servicio a clientes o usuarios:',
            'SECCION1_LABEL02':' Si su respuesta fue "SÍ", responda las preguntas siguientes. Si su respuesta fue "NO", ha concluido el cuestionario.',
            'SECCION1_LABEL03':'Si su respuesta fue "SÍ", responda las preguntas siguientes. Si su respuesta fue "NO" pase a las preguntas de la sección siguiente.',
            'SECCION1_LABEL04':'Las siguientes preguntas están relacionadas con las actitudes de los trabajadores que supervisa.',

            'SECCION2_LABEL01':'En mi trabajo debo brindar servicio a clientes o usuarios:',
            'SECCION2_LABEL02':' Si su respuesta fue "SÍ", responda las preguntas siguientes. Si su respuesta fue "NO", ha concluido el cuestionario.',
            'SECCION2_LABEL03':' Si su respuesta fue "SÍ", responda las preguntas siguientes. Si su respuesta fue "NO" pase a las preguntas de la sección siguiente.',
            'SECCION2_LABEL04':'Las preguntas siguientes están relacionadas con las actitudes de las personas que supervisa.',
            'SECCION1':{
              'DESCRIPTION':'Para responder las preguntas siguientes considere las condiciones ambientales de su centro de trabajo.',
              'QUES1':'El espacio donde trabajo me permite realizar mis actividades de manera segura e higiénica',
              'QUES2':'Mi trabajo me exige hacer mucho esfuerzo físico',
              'QUES3':'Me preocupa sufrir un accidente en mi trabajo',
              'QUES4':'Considero que en mi trabajo se aplican las normas de seguridad y salud en el trabajo',
              'QUES5':'	Considero que las actividades que realizo son peligrosas',
            },
            'SECCION2':{
              'DESCRIPTION':'Para responder a las preguntas siguientes piense en la cantidad y ritmo de trabajo que tiene.',
              'QUES1':'Por la cantidad de trabajo que tengo debo quedarme tiempo adicional a mi turno',
              'QUES2':'	Por la cantidad de trabajo que tengo debo trabajar sin parar',
              'QUES3':'Considero que es necesario mantener un ritmo de trabajo acelerado',
            },
            'SECCION3':{
              'DESCRIPTION':'Las preguntas siguientes están relacionadas con el esfuerzo mental que le exige su trabajo.',
              'QUES1':'	Mi trabajo exige que esté muy concentrado',
              'QUES2':'	Mi trabajo requiere que memorice mucha información',
              'QUES3':'En mi trabajo tengo que tomar decisiones difíciles muy rápido',
              'QUES4':'Mi trabajo exige que atienda varios asuntos al mismo tiempo'
            },
            'SECCION4':{
              'DESCRIPTION':'Las preguntas siguientes están relacionadas con las actividades que realiza en su trabajo y las responsabilidades que tiene.',
              'QUES1':'	En mi trabajo soy responsable de cosas de mucho valor',
              'QUES2':'	Respondo ante mi jefe por los resultados de toda mi área de trabajo',
              'QUES3':'En el trabajo me dan órdenes contradictorias',
              'QUES4':'	Considero que en mi trabajo me piden hacer cosas innecesarias'
            },
            'SECCION5':{
              'DESCRIPTION':'Las preguntas siguientes están relacionadas con su jornada de trabajo.',
              'QUES1':'Trabajo horas extras más de tres veces a la semana	',
              'QUES2':'Mi trabajo me exige laborar en días de descanso, festivos o fines de semana	',
              'QUES3':'Considero que el tiempo en el trabajo es mucho y perjudica mis actividades familiares o personales ',
              'QUES4':' Debo atender asuntos de trabajo cuando estoy en casa',
              'QUES5':' Pienso en las actividades familiares o personales cuando estoy en mi trabajo',
              'QUES6':' Pienso que mis responsabilidades familiares afectan mi trabajo'
            },
            'SECCION6':{
              'DESCRIPTION':' Las preguntas siguientes están relacionadas con las decisiones que puede tomar en su trabajo.',
              'QUES1':'Mi trabajo permite que desarrolle nuevas habilidades',
              'QUES2':'En mi trabajo puedo aspirar a un mejor puesto',
              'QUES3':'Durante mi jornada de trabajo puedo tomar pausas cuando las necesito ',
              'QUES4':'Puedo decidir cuánto trabajo realizo durante la jornada laboral',
              'QUES5':'Puedo decidir la velocidad a la que realizo mis actividades en mi trabajo ',
              'QUES6':'Puedo cambiar el orden de las actividades que realizo en mi trabajo '
            },
            'SECCION7':{
              'DESCRIPTION':'Las preguntas siguientes están relacionadas con cualquier tipo de cambio que ocurra en su trabajo (considere los últimos cambios realizados).',
              'QUES1':'Los cambios que se presentan en mi trabajo dificultan mi labor	',
              'QUES2':'Cuando se presentan cambios en mi trabajo se tienen en cuenta mis ideas o aportaciones	',
            },
            'SECCION8':{
              'DESCRIPTION':'Las preguntas siguientes están relacionadas con la capacitación e información que se le proporciona sobre su trabajo ',
              'QUES1':'Me informan con claridad cuáles son mis funciones	',
              'QUES2':'Me explican claramente los resultados que debo obtener en mi trabajo	',
              'QUES3':'Me explican claramente los objetivos de mi trabajo',
              'QUES4':'Me informan con quién puedo resolver problemas o asuntos de trabajo',
              'QUES5':'Me permiten asistir a capacitaciones relacionadas con mi trabajo ',
              'QUES6':'Recibo capacitación útil para hacer mi trabajo'
            },
            'SECCION9':{
              'DESCRIPTION':'Las preguntas siguientes están relacionadas con el o los jefes con quien tiene contacto. ',
              'QUES1':'Mi jefe ayuda a organizar mejor el trabajo	',
              'QUES2':'Mi jefe tiene en cuenta mis puntos de vista y opiniones',
              'QUES3':'Mi jefe me comunica a tiempo la información relacionada con el trabajo ',
              'QUES4':'La orientación que me da mi jefe me ayuda a realizar mejor mi trabajo ',
              'QUES5':'Mi jefe ayuda a solucionar los problemas que se presentan en el trabajo'
            },
            'SECCION10':{
              'DESCRIPTION':'Las preguntas siguientes se refieren a las relaciones con sus compañeros ',
              'QUES1':'Puedo confiar en mis compañeros de trabajo	',
              'QUES2':'Entre compañeros solucionamos los problemas de trabajo de forma respetuosa	',
              'QUES3':'En mi trabajo me hacen sentir parte del grupo ',
              'QUES4':'Cuando tenemos que realizar trabajo de equipo los compañeros colaboran',
              'QUES5':'Mis compañeros de trabajo me ayudan cuando tengo dificultades'
            },
            'SECCION11':{
              'DESCRIPTION':'Las preguntas siguientes están relacionadas con la información que recibe sobre su rendimiento en el trabajo, el reconocimiento, el sentido de pertenencia y la estabilidad que le ofrece su trabajo. ',
              'QUES1':'Me informan sobre lo que hago bien en mi trabajo	',
              'QUES2':'La forma como evalúan mi trabajo en mi centro de trabajo me ayuda a mejorar mi desempeño',
              'QUES3':'	En mi centro de trabajo me pagan a tiempo mi salario ',
              'QUES4':'El pago que recibo es el que merezco por el trabajo que realizo ',
              'QUES5':'Si obtengo los resultados esperados en mi trabajo me recompensan o reconocen',
              'QUES6':'Las personas que hacen bien el trabajo pueden crecer laboralmente ',
              'QUES7':'Considero que mi trabajo es estable',
              'QUES8':'En mi trabajo existe continua rotación de personal ',
              'QUES9':'Siento orgullo de laborar en este centro de trabajo ',
              'QUES10':'Me siento comprometido con mi trabajo'
            },
            'SECCION12':{
              'DESCRIPTION':'Las preguntas siguientes están relacionadas con actos de violencia laboral (malos tratos, acoso, hostigamiento, acoso psicológico). ',
              'QUES1':'En mi trabajo puedo expresarme libremente sin interrupciones	',
              'QUES2':'Recibo críticas constantes a mi persona y/o trabajo',
              'QUES3':'Recibo burlas, calumnias, difamaciones, humillaciones o ridiculizaciones',
              'QUES4':'Se ignora mi presencia o se me excluye de las reuniones de trabajo y en la toma de decisiones',
              'QUES5':'Se manipulan las situaciones de trabajo para hacerme parecer un mal trabajador',
              'QUES6':'Se ignoran mis éxitos laborales y se atribuyen a otros trabajadores',
              'QUES7':'	Me bloquean o impiden las oportunidades que tengo para obtener ascenso o mejora en mi trabajo',
              'QUES8':'He presenciado actos de violencia en mi centro de trabajo '
            },
            'SECCION13':{
              'DESCRIPTION':'Las preguntas siguientes están relacionadas con la atención a clientes y usuarios. ',
              'QUES1':'Atiendo clientes o usuarios muy enojados	',
              'QUES2':'Mi trabajo me exige atender personas muy necesitadas de ayuda o enfermas	',
              'QUES3':'Para hacer mi trabajo debo demostrar sentimientos distintos a los míos',
              'QUES4':'Mi trabajo me exige atender situaciones de violencia '
            },
            'SECCION14':{
              'DESCRIPTION':'Soy jefe de otros trabajadores ',
              'QUES1':'Comunican tarde los asuntos de trabajo	',
              'QUES2':'Dificultan el logro de los resultados del trabajo	',
              'QUES3':'Cooperan poco cuando se necesita ',
              'QUES4':'Ignoran las sugerencias para mejorar su trabajo'
            },


          }
        },

        'Guia4':{
          'TITLE':'Guía de referencia IV ',
          'SUBTITLE':'EJEMPLO DE POLÍTICA DE PREVENCIÓN DE RIESGOS PSICOSOCIALES',
          'CONTENT':'El contenido de esta guía es un complemento para la mejor comprensión de la presente norma, y no es de cumplimiento obligatorio.',
          'MAIN_CONTENT':{
            'TITLE':'POLÍTICA DE PREVENCIÓN DE RIESGOS PSICOSOCIALES: ',
            'PAF1':'En este centro de trabajo (Razón Social) en relación con la prevención de los factores de riesgo psicosocial; la prevención de la violencia laboral, y la promoción de un entorno organizacional favorable, se asumen los compromisos siguientes:',
            'PAF2':'Es obligación de supervisores, gerentes y directores aplicar esta política y predicar con el ejemplo; los actos de violencia laboral no son tolerados, así como ningún incidente que propicie factores de riesgo psicosocial o acciones en contra del entorno organizacional favorable; se aplican medidas encaminadas a la prevención de los factores de riesgo psicosocial; la prevención de la violencia laboral, y la promoción de un entorno organizacional favorable, para prevenir sus consecuencias adversas.',
            'PAF3':'Se cuenta con un procedimiento de atención justo, que no permite represalias y evita reclamaciones abusivas o carentes de fundamento, y que garantiza la confidencialidad de los casos.',
            'PAF4':'Se realizan acciones de sensibilización, programas de información y capacitación.',
            'PAF5':'Se divulgan de forma eficaz las políticas de prevención y las medidas de prevención; todos los trabajadores participan para establecer y poner en práctica esta política en el lugar de trabajo; se respeta al ejercicio de los derechos del personal para observar sus creencias o prácticas o para satisfacer sus necesidades relacionadas con la raza, sexo, religión, etnia o edad o cualquier otra condición que pueda dar origen a la discriminación, y se crean espacios de participación y consulta, teniendo en cuenta las ideas de los trabajadores y empleados.',
            'NOTA':{
              'DES':'Nota: La política deberá indicar a los responsables (con capacidad para su aplicación) y los recursos que se disponen para cumplir con las políticas en todos los planos de la organización; la asignación de responsabilidades tanto a las personas como a los equipos de trabajo, los cuales reciben la',
              'NOT1':'1. Para favorecer un entorno organizacional favorable, en el centro de trabajo se:',
              'NOT1_P':{
                'A':'a) Realizan reuniones con los trabajadores para que todos tengan la oportunidad de exponer sus dudas, inquietudes, quejas relacionadas con su trabajo.',
                'B':'b) Mantienen limpias las áreas de trabajo; así como las áreas comunes: comedor, baños, sanitarios, accesos.',
                'C':'c) Trata con amabilidad y cortesía a los compañeros de trabajo, jefes, subalternos, visitantes, proveedores, clientes.',
                'D':'d) Atienden todos los casos relacionados con burlas, malos tratos, discriminación, etc., y en su caso, se sancionan estos.',
                'E':'e) Realizan exámenes médicos al personal de nuevo ingreso para procurar y mantener su salud.',
                'F':'f) Llevan a cabo exámenes psicológicos y/o psicométricos para situar a cada trabajador en el puesto para el cual cuente con capacidades y preparación acordes.',
                'G':'g) Realizan planes de promoción interna, y',
                'H':'h) Capacita a todo el personal para el desempeño de sus funciones, su seguridad y desarrollo.',
              },
              'NOT2':'2. En este centro de trabajo, para promover el sentido de pertenencia de los trabajadores a la organización, se hace hincapié en que todas y todos los trabajadores y empleados son importantes para el centro de trabajo, ya que el mismo no puede funcionar si no se cuenta con personal desde el de limpieza, pasando por el operativo, administrativo y hasta el directivo.',
              'NOT3':'3. Este centro de trabajo para lograr la adecuada realización de las tareas encomendadas, imparte a sus trabajadores y empleados la capacitación establecida en la Ley Federal del Trabajo, acorde a las actividades que desempeñan.',
              'NOT4':'4. En este centro de trabajo para lograr la definición precisa de responsabilidades para los trabajadores, se difunde y promueve el seguimiento a los manuales de organización y las descripciones de puesto que indican las responsabilidades específicas de cada puesto de trabajo.',
              'NOT5':'5. Para lograr la participación proactiva y comunicación entre sus integrantes, este centro de trabajo publica en tableros anuncios, noticias y avisos de interés para sus trabajadores y empleados relativos a las labores y operaciones de la misma, y estos, a su vez, pueden publicar en dichos tableros el mismo tipo de anuncios, noticias y avisos. En estos tableros no se incluyen avisos que no están estrictamente relacionados con las labores del centro de trabajo.',
              'NOT6':'6. Para promover un trabajo digno y lograr un entorno organizacional favorable, este centro de trabajo realiza una distribución adecuada de cargas de trabajo, con jornadas de trabajo conforme a la Ley Federal de Trabajo, para tal efecto, define en los manuales de organización y en las descripciones de puesto que se emiten, así como en el Reglamento Interior de Trabajo, en función de la naturaleza específica de la labor de que se trate.',
              'NOT7':'7. Para reconocer el desempeño de los trabajadores en el centro de trabajo, se evalúa por lo menos una vez al año el desempeño de cada uno de sus trabajadores y empleados, lo cual se lleva a cabo personalmente por conducto del supervisor o jefe inmediato del trabajador o empleado de que se trate y los resultados de la misma sirven de base para la determinación del reconocimiento o beneficios a los trabajadores sobresalientes.',
              'NOT8':'8. Este centro de trabajo se compromete a vigilar el cumplimiento de las normas dirigidas a prevenir cualquier conducta o comportamiento que implique violencia laboral, a salvaguardar la información que sea recolectada, dar trámite e intervenir, de forma oportuna, en las quejas que se reciban por los medios establecidos.',
            }

          }
        },
        'Guia5':{
          'TITLE':'Guía de referencia V',
          'SUBTITLE':'DATOS DEL TRABAJADOR',
          'DES':'El contenido de esta guía es un complemento para la mejor comprensión de la presente Norma, y no es de cumplimiento obligatorio',
          'CONTENT':{
            'TITLE':'Información del trabajador',
            'LABEL01':'Sexo:',
            'LABEL02':'Masculino:',
            'LABEL03':'Femenino:',
            'LABEL04':'Edad en años:',
            'LABELYEAR01':'años',
            'LABELYEAR02':'o más',
            'ESTADO':{
              'TITLE':'Estado civil:',
              'LABEL01':'Casado',
              'LABEL02':'Soltero',
              'LABEL03':'Unión libre',
              'LABEL04':'Divorciado',
              'LABEL05':'Viudo'
            },
            'ESTUDIOS':{
              'TITLE':'Nivel de estudios',
              'LABEL01':'Sin formación',
              'LABEL02':'Primaria',
              'LABEL03':'Secundaria',
              'LABEL04':'Preparatoria o Bachillerato',
              'LABEL05':'Técnico Superior',
              'LABEL06':'Licenciatura',
              'LABEL07':'Maestria',
              'LABEL08':'Doctorado',
              'OPC1':'Terminada',
              'OPC2':'Incompleta',
            },
            'LABEL05':'Datos laborales:',
            'LABEL06':'Ocupación/Profesión/Puesto:',
            'LABEL07':'Departamento/Sección/Área:',
            'PUESTO':{
              'TITLE':'Tipo de puesto:',
              'LABEL01':'Operativo',
              'LABEL02':'Supervisor',
              'LABEL03':'Profesional',
              'LABEL04':'Gerente',
            },
            'CONTRATACION':{
              'TITLE':'Tipo de contratación:',
              'LABEL01':'Por obra o proyecto',
              'LABEL02':'Tiempo indeterminado',
              'LABEL03':'Profesional o técnico',
              'LABEL04':'Honorarios',
            },
            'PERSONAL':{
              'TITLE':'Tipo de personal:',
              'LABEL01':'Sindicalizado',
              'LABEL02':'Ninguno',
              'LABEL03':'Confianza',
            },
            'JORNADA':{
              'TITLE':'Tipo de jornada de trabajo:',
              'LABEL01':'Fijo nocturno (entre las 20:00 y 6:00 hrs)',
              'LABEL02':'Fijo mixto (combinación de nocturno y diurno)',
              'LABEL03':'Fijo diurno (entre las 6:00 y 20:00 hrs)',
            },
            'ROTACION':{
              'TITLE': 'Realiza rotación de turnos:',
              'OPC1': 'SÍ',
              'OPC2': 'NO'
            },
            'EXPERIENCIA':{
              'TITLE':'Experiencia (años):',
              'SUBTITLE':'Tiempo en el puesto actual:',
              'LABEL01':'Menos de 6 meses',
              'LABEL02':'Entre 6 meses y 1 año',
              'LABEL03':'Entre 1 a 4 años',
              'LABEL04':'Entre 5 a 9 años',
              'LABEL05':'Entre 10 a 14 años',
              'LABEL06':'Entre 15 a 19 años',
              'LABEL07':'Entre 20 a 24 años',
              'LABEL08':'25 años o más',
              'LABELIN':'Tiempo experiencia laboral:',
              'LABEL09':'Menos de 6 meses',
              'LABEL10':'Entre 6 meses y 1 año',
              'LABEL11':'Entre 1 a 4 años',
              'LABEL12':'Entre 5 a 9 años',
              'LABEL13':'Entre 10 a 14 años',
              'LABEL14':'Entre 15 a 19 años',
              'LABEL15':'Entre 20 a 24 años',
              'LABEL16':'25 años o más'

            },

          }

        },
      }
    }

};
